// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "route__info-sZp3Z";
var _4 = "row-1_z4D";
var _5 = "arrow_container-vPIqn";
var _6 = "totalDuration-3x4Fy";
export { _1 as "__esModule", _2 as "mobile", _3 as "route__info", _4 as "row", _5 as "arrow_container", _6 as "totalDuration" }
export default { "__esModule": _1, "mobile": _2, "route__info": _3, "row": _4, "arrow_container": _5, "totalDuration": _6 }
